let defaultTitle = 'calibration'
const environment = window.config ? window.config.environment : 'local'

export default (to, from, next) => {
  // collect environment
  let env = environment === 'prod' ? '' : `[${environment}]`

  let solutions = window.config ? window.config.solutions : []
  if (solutions.length === 1) {
    defaultTitle = 'diagnostics'
  }
  // set default
  document.title = `${defaultTitle} ${env}`.trim()

  if (to.name) {
    document.title = `${to.name} - ${defaultTitle} ${env}`.trim()
  }
}
